module.exports = __webpack_public_path__ + "img/云稼智农-app下载页.72a3af82.png";